/* eslint-disable import/prefer-default-export */
import { createRouter, createWebHistory } from 'vue-router';
import CartRoutes from './features/cart/cart.routing';
import CheckoutRoutes from './features/checkout/checkout.routing';
import MainRoutes from './features/main/main.routing';
const routes = [...CartRoutes, ...CheckoutRoutes, ...MainRoutes];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach((to) => {
    document.title = `${to.meta.title} | My Pro Images`;
});
export { router };
